import { gtagCategoricalEvent } from '../../utils/gtag'

export const sweepstakesEvent = gtagCategoricalEvent('sweepstakes')
